import React, { useState, useEffect, useRef } from "react";
import io from "socket.io-client";
import Picker from "@emoji-mart/react";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import SendIcon from "@mui/icons-material/Send";
import { TextField } from "@mui/material";
import WrapperCard from "../../component-lib/Atoms/card/EventEHRWrapperCard";
import { startChat } from "../../assets";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded"; // Socket.IO client setup
import moment from "moment";
import EventEHRImageAvatar from "../../component-lib/Atoms/image-avatar/EventEHRImageAvatar";
import Heading from "../../component-lib/Atoms/heading/EventEHRHeading";
import { useDispatch, useSelector } from "react-redux";
import {
  getConversationList,
  getGroupCreated,
  patchConversationData,
  patchGroupMemberAndGroupName,
} from "./messagingSaga";
import {
  componentKey,
  setCloseCreateGroup,
  setIsUserAdded,
} from "./messagingSlice";
import { getLoginUserId } from "../../utils/getToken";
import MenuDropdown from "../../component-lib/Molecules/menuDropdown/MenuDropdown";
import UsersList from "./UsersList";
import GroupChatDialog from "./group-chat/CreateGroupChatDialog";
import ViewMembersDialog from "./group-chat/ViewMembersDialog/ViewMembersDialog";
import useChatSocket, {
  socket,
} from "../../custom-hooks/UseChatSocket"; // ✅ Dedicated chat socket (separate from notifications)

const ChatBox = () => {
  const { conversationList, isUserAdded, closeCreateGroup } = useSelector(
    (state: any) => state[componentKey]
  );
  const parseLoginUserId: any = getLoginUserId();
  const loginUserId = JSON.parse(parseLoginUserId);
  const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

  // Use chat socket hook (keeps the socket connection alive)
  useChatSocket(loginUserId);

  const dispatch = useDispatch();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [messages, setMessages] = useState<string[]>([]);
  const [groupMessages, setGroupMessages] = useState<any>({});
  const [input, setInput] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [selectedProviderMsg, setSelectedProviderMsg] = useState<any>({});
  const [selectedGroupMessages, setSelectedGroupMessages] = useState<any>({});
  // const [socket, setSocket] = useState<any>(null);
  const [selectedUserId, setSelectedUserId] = useState<any>(null);
  const [isNewMessage, setIsNewMessage] = useState({});
  const [selectedTabForUser, setSelectedTabForUser] = useState("Chats");
  const [groupNameAndGroupMember, setGroupNameAndGroupMember] = useState(false);
  const [openViewMembersDialog, setOpenViewMembersDialog] = useState(false);

  const permission = [
    {
      label: "View Members",
      onClickCb: () => {
        setOpenViewMembersDialog(true);
      },
    },
  ];

  if (selectedGroupMessages?.createdBy === loginUserId) {
    permission.push({
      label: "Group Setting",
      onClickCb: () => {
        setGroupNameAndGroupMember(true);
      },
    });
  }

  // COMMON STYLE
  const commonBgColor = { color: "#565656" };

  // GET USER LIST
  useEffect(() => {
    if (selectedTabForUser === "Chats") {
      const payload = {
        userId: loginUserId,
      };
      dispatch(getConversationList(payload));
    } else {
      const payload = {
        userId: loginUserId,
      };

      dispatch(getGroupCreated(payload));
    }
  }, []);

  // GET CONVERSATION LIST
  useEffect(() => {
    if (selectedTabForUser === "Chats") {
      if (isUserAdded) {
        const payload = {
          userId: loginUserId,
        };
        dispatch(getConversationList(payload));
        dispatch(setIsUserAdded(false));
      }
    } else {
      const payload = {
        userId: loginUserId,
      };

      dispatch(getGroupCreated(payload));
    }
  }, [isUserAdded]);

  // // Initialize socket connection
  // useEffect(() => {
  //   // if (selectedTabForUser === "Chats") {
  //   const socketInstance = io(SOCKET_URL, { query: { userId: loginUserId } });
  //   // Listen for successful connection
  //   socketInstance.on("connect", () => {
  //     console.log("Socket connected:");
  //   });

  //   // Listen for disconnection
  //   socketInstance.on("disconnect", (reason) => {
  //     console.log("Socket disconnected:", reason);
  //   });

  //   // Set the socket
  //   setSocket(socketInstance);

  //   // Cleanup function
  //   return () => {
  //     socketInstance.disconnect();
  //     console.log("Socket connection cleaned up");
  //   };
  //   // }
  //   // else {
  //   // }
  // }, [loginUserId]);

  useEffect(() => {
    if (!socket || !loginUserId) return;

    if (selectedTabForUser === "Chats") {
      if (socket && selectedProviderMsg) {
        // Define the fetch messages function
        const fetchMessages = () => {
          socket?.emit("getMessages", {
            userId: loginUserId,
            otherUserId: selectedProviderMsg?.connectedUser?.id,
          });
        };

        // Initial fetch
        fetchMessages();

        // Set up interval for periodic fetching
        const intervalId = setInterval(fetchMessages, 500); // Fetch messages every 5 seconds

        // Listen for the response
        socket.on(
          `${loginUserId}_${selectedProviderMsg?.connectedUser?.id}`,
          (response: any) => {
            if (response) {
              console.log("Received message history:");
              setMessages(response); // Set only the 'data' field
            } else {
              console.warn("Invalid response format:", response);
            }
          }
        );

        // Cleanup on unmount or dependency change
        return () => {
          clearInterval(intervalId); // Clear the interval
          socket?.off("getMessages");
          console.log("Cleaned up getMessages listener and interval");
        };
      }
    } else {
      if (socket && selectedGroupMessages) {
        // Define the fetch messages function
        const fetchMessages = () => {
          socket?.emit("getGroupMessages", {
            // userId: loginUserId,
            groupId: selectedGroupMessages?.id,
          });
        };

        // Initial fetch
        fetchMessages();

        // Set up interval for periodic fetching
        const intervalId = setInterval(fetchMessages, 500); // Fetch messages every 5 seconds

        // Listen for the response
        socket.on(`getGroupMessages`, (response: any) => {
          if (response) {
            if (response?.groupId === selectedGroupMessages?.id) {
              console.log("Received message history2:", response);
              setGroupMessages(response); // Set only the 'data' field
            }
          } else {
            console.warn("Invalid response format2:");
          }
        });

        // Cleanup on unmount or dependency change
        return () => {
          clearInterval(intervalId); // Clear the interval
          socket?.off("getGroupMessages");
          console.log("Cleaned up getMessages listener and interval2");
        };
      }
    }
  }, [socket, selectedProviderMsg, isNewMessage, selectedGroupMessages]);

  //IF USER SELECT USER FROM SEARCH THEN WE NEED TO SHOW USER'S CHAT
  useEffect(() => {
    if (selectedTabForUser === "Chats") {
      const selectedUser = conversationList?.find(
        (data: any) => selectedUserId === data?.connectedUser?.id
      );
      setSelectedProviderMsg(selectedUser);
    } else {
    }
  }, [conversationList]);

  // THIS USE EFFECT CHECKING OVERFLOW AT BOTTOM
  useEffect(() => {
    if (selectedTabForUser === "Chats") {
      if (containerRef.current) {
        containerRef.current.scrollTop = containerRef.current.scrollHeight;
      }
    } else {
    }
  }, [isNewMessage]);

  // USING THIS FUNCTION WE ARE SENDING MESSAGE
  const sendMessage = () => {
    if (selectedTabForUser === "Chats") {
      if (socket && input.trim() && selectedProviderMsg) {
        const newMessage = {
          content: input,
          senderId: loginUserId,
          receiverId: selectedProviderMsg?.connectedUser.id,
          // timestamp: new Date().toISOString(),
        };
        setIsNewMessage(newMessage);

        // Emit the message to the server
        socket.emit("sendMessage", newMessage);

        // Optimistically update the message list
        // setMessages((prev: any) => [...prev, newMessage]);
        setInput("");
      }
    } else {
      if (socket && input.trim() && selectedGroupMessages) {
        const newMessage = {
          content: input,
          senderId: loginUserId,
          groupId: selectedGroupMessages.id,
          // timestamp: new Date().toISOString(),
        };
        setIsNewMessage(newMessage);

        // Emit the message to the server
        socket.emit("sendGroupMessage", newMessage);

        // Optimistically update the message list
        // setMessages((prev: any) => [...prev, newMessage]);
        setInput("");
      }
    }
  };

  // Pin/ Unpin Chat function
  const pinChat = (isPin: Boolean, id: string) => {
    if (selectedTabForUser === "Chats") {
      const payload = {
        apiPayload: {
          pin: !isPin,
        },
        id: id,
      };
      dispatch(patchConversationData(payload));
    } else {
    }
  };

  // Other Tools functions implementation
  const handleEmojiSelect = (emoji: any) => {
    setInput(input + emoji.native);
  };
  const handlerForAddGroupMemberAndGroupName = (data: any) => {
    if (selectedGroupMessages && selectedGroupMessages?.id) {
      const apiPayload = {
        payload: {
          name: data?.groupName || "",
          userIds: data?.userName?.length
            ? data?.userName?.map((item: any) => item?.values || item?.value)
            : [],
        },
        groupId: selectedGroupMessages?.id,
      };

      dispatch(patchGroupMemberAndGroupName(apiPayload));
    }
  };

  useEffect(() => {
    if (closeCreateGroup) {
      setGroupNameAndGroupMember(false);
      dispatch(setCloseCreateGroup(false));
      const payload = {
        userId: loginUserId,
      };
      setSelectedGroupMessages({});
      dispatch(getGroupCreated(payload));
    }
  }, [closeCreateGroup]);

  return (
    <WrapperCard customClasses="m-3 h-[calc(100vh-97px)] overflow-hidden">
      <div
        className=""
        style={{
          display: "grid",
          gridTemplateColumns: "minmax(300px, 360px) 1fr",
        }}
      >
        {/* USERS AND SEARCH */}
        <UsersList
          conversationList={conversationList}
          selectedProviderMsg={
            selectedTabForUser === "Chats"
              ? selectedProviderMsg
              : selectedGroupMessages
          }
          selectedTabForUser={selectedTabForUser}
          handlePinMessage={(pin, messageId, id) => {
            pinChat(pin, messageId);
            setSelectedUserId(id);
          }}
          handleSetSelectedValue={(id) => setSelectedUserId(id)}
          onClickUser={(data) => {
            setSelectedProviderMsg(data);
            setMessages([]);
          }}
          onClickGroup={(data) => {
            setSelectedGroupMessages(data);
            // setMessages([]);
          }}
          setSelectedTab={(selectedTab) => {
            setSelectedTabForUser(selectedTab);
          }}
        />

        {/* PART 2 PROVIDER DETAILS AND MESSAGES  FOR ONEW TO ONE CHATS*/}
        {selectedTabForUser === "Chats" && selectedProviderMsg?.id ? (
          <div style={{ width: "100%", margin: "0" }}>
            <div
              className="px-6 py-[18.5px] flex justify-between items-center"
              style={{ borderBottom: "1px solid #D2D2D2" }}
            >
              <div className="flex items-center gap-2">
                <EventEHRImageAvatar
                  image={""}
                  commonStyle={{
                    width: "35px",
                    height: "35px",
                    border: "2px solid #BCBCBC",
                    borderRadius: "50%",
                    overflow: "auto",
                  }}
                  customTextStyle={{ fontSize: "14px", fontWeight: "bold" }}
                  customImageStyle={{
                    borderRadius: "50%",
                  }}
                  labelText={`${selectedProviderMsg?.connectedUser?.firstName} ${selectedProviderMsg?.connectedUser?.lastName}`}
                />
                <h1 className="text-base font-semibold text-[#393939]">
                  {`${selectedProviderMsg?.connectedUser?.firstName} ${selectedProviderMsg?.connectedUser?.lastName}`}
                </h1>
              </div>
              <MenuDropdown
                options={[
                  {
                    label: selectedProviderMsg?.pin ? "Unpin Chat" : "Pin Chat",
                    onClickCb: () => {
                      pinChat(
                        selectedProviderMsg?.pin,
                        selectedProviderMsg?.id
                      );
                      setSelectedUserId(selectedProviderMsg?.connectedUser?.id);
                    },
                  },
                ]}
              />
            </div>
            {/* MESSAGES */}
            <div
              ref={containerRef}
              className="flex justify-start items-end p-[10px] overflow-auto flex-col-reverse"
              style={{
                height: "calc(100vh - 242px)",
              }}
            >
              {messages
                ?.reduce((acc: any[], msg: any, index: number) => {
                  const messageDate = moment(msg?.createdAt).startOf("day");
                  const today = moment().startOf("day");
                  const tomorrow = moment().add(1, "day").startOf("day");

                  let label = "";
                  if (messageDate.isSame(today)) {
                    label = "Today";
                  } else if (messageDate.isSame(tomorrow)) {
                    label = "Tomorrow";
                  } else {
                    label = messageDate.format("MMMM DD, YYYY");
                  }

                  if (
                    !acc.some(
                      (item) =>
                        item.type === "date" &&
                        moment(item.date).isSame(messageDate, "day")
                    )
                  ) {
                    acc.push({ type: "date", label, date: messageDate });
                  }

                  acc.push({ ...msg, type: "message" });
                  return acc;
                }, [])
                .map((item, index) => {
                  if (item.type === "date") {
                    return (
                      <div
                        key={`date-${index}`}
                        className="w-full flex items-center my-2"
                      >
                        <div className="flex-grow border-t border-gray-300"></div>
                        <span className="mx-2 text-sm text-gray-500">
                          {item.label}
                        </span>
                        <div className="flex-grow border-t border-gray-300"></div>
                      </div>
                    );
                  }
                  const msg = item;
                  const isMine =
                    (msg?.senderId ?? msg?.senderAdminId) === loginUserId;
                  return (
                    <div
                      key={index}
                      className={!isMine ? "self-start" : "self-end"}
                    >
                      {msg.type === "file" ? (
                        <div className="mt-2 flex items-end flex-col gap-1">
                          <div
                            className="p-4 pl-6 text-[white] font-medium max-w-[500px]
bg-[#e9e9e9] rounded-tl-[12px] rounded-tr-[12px] rounded-bl-[12px] rounded-br-none"
                          >
                            <a
                              href={msg.content.data}
                              download={msg.content.name}
                              style={{
                                color: "blue",
                                textDecoration: "underline",
                              }}
                            >
                              {msg.content.name}
                            </a>
                          </div>
                          <span className="font-normal text-sm text-[#8F8F8F]">
                            {msg?.time}
                          </span>
                        </div>
                      ) : (
                        <div className="mt-2 flex items-end flex-col gap-1">
                          <div
                            className={`p-4 font-medium max-w-[500px]
                    rounded-tl-[12px] rounded-tr-[12px] ${
                      !isMine
                        ? "rounded-br-[12px] rounded-bl-none bg-[#F4F4F4] text-[#393939]"
                        : "rounded-br-none rounded-bl-[12px] bg-[#005596] text-[white]"
                    }`}
                          >
                            {msg.content ? msg.content : msg?.message}
                          </div>
                          <span
                            className={`font-normal text-sm text-[#8F8F8F] ${
                              !isMine ? "self-start" : "self-end"
                            }`}
                          >
                            {msg?.createdAt
                              ? moment(msg?.createdAt)?.format("HH:mm")
                              : ""}
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })
                .reverse()}
            </div>
            {/* MESSAGE TYPE TOOL */}
            <div className="mx-6 my-4">
              <div className="flex items-center">
                {/* Emoji Picker Toggle */}
                <span className="mr-2">
                  <button onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                    <SentimentSatisfiedAltIcon style={commonBgColor} />
                  </button>
                </span>
                <TextField
                  fullWidth
                  value={input}
                  size="small"
                  // rows={1}
                  // multiline={true}
                  placeholder="Type your message here ..."
                  onChange={(e) => setInput(e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "25px", // Set your desired border-radius here
                      backgroundColor: "#F4F4F4", // Set your desired background color
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove the outline
                    },
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && input.trim() !== "") {
                      sendMessage();
                    }
                  }}
                  slotProps={{
                    input: {
                      endAdornment:
                        input !== "" ? (
                          <SendIcon
                            style={commonBgColor}
                            onClick={sendMessage}
                            className="cursor-pointer"
                          />
                        ) : (
                          <label>
                            <SendIcon
                              style={commonBgColor}
                              onClick={() => {}}
                            />
                          </label>
                        ),
                    },
                  }}
                />
              </div>

              {/* Emoji Picker */}
              {showEmojiPicker && (
                <div
                  className="flex flex-col"
                  style={{ position: "absolute", bottom: "80px", zIndex: 1000 }}
                >
                  <CancelRoundedIcon
                    className="self-end text-[#8a2222] cursor-pointer mb-1"
                    onClick={() => {
                      setShowEmojiPicker(false);
                    }}
                  />
                  <Picker onEmojiSelect={handleEmojiSelect} />
                </div>
              )}
            </div>
          </div>
        ) : selectedTabForUser ===
            "Group Chats" /* PART 2 PROVIDER DETAILS AND MESSAGES  FOR GROUP CHAT*/ &&
          selectedGroupMessages?.id ? (
          <div style={{ width: "100%", margin: "0" }}>
            <div
              className="px-6 py-[18.5px] flex justify-between items-center"
              style={{ borderBottom: "1px solid #D2D2D2" }}
            >
              <div className="flex items-center gap-2">
                <EventEHRImageAvatar
                  image={""}
                  commonStyle={{
                    width: "35px",
                    height: "35px",
                    border: "2px solid #BCBCBC",
                    borderRadius: "50%",
                    overflow: "auto",
                  }}
                  customTextStyle={{ fontSize: "14px", fontWeight: "bold" }}
                  customImageStyle={{
                    borderRadius: "50%",
                  }}
                  labelText={`${selectedGroupMessages?.name}`}
                />
                <h1 className="text-base font-semibold text-[#393939]">
                  {`${selectedGroupMessages?.name}`}
                </h1>
              </div>
              <MenuDropdown options={permission} />
            </div>
            {/* MESSAGES */}
            <div
              ref={containerRef}
              className="flex justify-start items-end p-[10px] overflow-auto flex-col-reverse"
              style={{
                height: "calc(100vh - 242px)",
              }}
            >
              {groupMessages?.groupChat
                ?.reduce((acc: any[], msg: any, index: number) => {
                  const messageDate = moment(msg?.createdAt).startOf("day");
                  const today = moment().startOf("day");
                  const tomorrow = moment().add(1, "day").startOf("day");

                  let label = "";
                  if (messageDate.isSame(today)) {
                    label = "Today";
                  } else if (messageDate.isSame(tomorrow)) {
                    label = "Tomorrow";
                  } else {
                    label = messageDate.format("MMMM DD, YYYY");
                  }

                  if (
                    !acc.some(
                      (item) =>
                        item.type === "date" &&
                        moment(item.date).isSame(messageDate, "day")
                    )
                  ) {
                    acc.push({ type: "date", label, date: messageDate });
                  }

                  acc.push({ ...msg, type: "message" });
                  return acc;
                }, [])
                ?.map((item: any, index: any) => {
                  if (item.type === "date") {
                    return (
                      <div
                        key={`date-${index}`}
                        className="w-full flex items-center my-2"
                      >
                        <div className="flex-grow border-t border-gray-300"></div>
                        <span className="mx-2 text-sm text-gray-500">
                          {item.label}
                        </span>
                        <div className="flex-grow border-t border-gray-300"></div>
                      </div>
                    );
                  }
                  const msg = item;
                  const isMine =
                    (msg?.senderId ?? msg?.senderAdminId) === loginUserId;
                  const senderMember = selectedGroupMessages?.memebers?.find(
                    (m: any) =>
                      m?.userId === msg?.senderId ||
                      m?.adminUserId === msg?.senderId
                  );
                  const senderInfo =
                    msg?.sender || senderMember?.users || senderMember?.adminUser;
                  const senderName =
                    senderInfo?.firstName || senderInfo?.lastName
                      ? `${senderInfo?.firstName ?? ""} ${senderInfo?.lastName ?? ""}`.trim()
                      : "-";
                  return (
                    <div
                      key={index}
                      className={
                        !isMine
                          ? "self-start"
                          : "self-end"
                      }
                    >
                      {msg.type === "file" ? (
                        <div className="mt-2 flex items-end flex-col gap-1">
                          <div
                            className="p-4 pl-6 text-[white] font-medium max-w-[500px]
bg-[#e9e9e9] rounded-tl-[12px] rounded-tr-[12px] rounded-bl-[12px] rounded-br-none"
                          >
                            <a
                              href={msg.content.data}
                              download={msg.content.name}
                              style={{
                                color: "blue",
                                textDecoration: "underline",
                              }}
                            >
                              {msg.content.name}
                            </a>
                          </div>
                          <span className="font-normal text-sm text-[#8F8F8F]">
                            {msg?.time}
                          </span>
                        </div>
                      ) : (
                        <div className="mt-2 flex items-end flex-col gap-1">
                          <div
                            className={`p-4 pt-2 font-medium max-w-[500px]
                    rounded-tl-[12px] rounded-tr-[12px] ${
                      !isMine
                        ? "rounded-br-[12px] rounded-bl-none bg-[#F4F4F4] text-[#393939]"
                        : "rounded-br-none rounded-bl-[12px] bg-[#005596] text-[white]"
                    }`}
                          >
                            <div
                              className={`text-[10px] ${isMine ? "text-[#ffcc00]" : "text-[#e95454]"} `}
                            >
                              {isMine ? "You" : senderName}
                            </div>
                            {msg.content ? msg.content : msg?.message}
                          </div>
                          <span
                            className={`font-normal text-sm text-[#8F8F8F] ${
                              !isMine
                                ? "self-start"
                                : "self-end"
                            }`}
                          >
                            {msg?.createdAt
                              ? moment(msg?.createdAt)?.format("HH:mm")
                              : ""}
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })
                .reverse()}
            </div>
            {/* MESSAGE TYPE TOOL */}
            <div className="mx-6 my-4">
              <div className="flex items-center">
                {/* Emoji Picker Toggle */}
                <span className="mr-2">
                  <button onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                    <SentimentSatisfiedAltIcon style={commonBgColor} />
                  </button>
                </span>
                <TextField
                  fullWidth
                  value={input}
                  size="small"
                  // rows={1}
                  // multiline={true}
                  placeholder="Type your message here ..."
                  onChange={(e) => setInput(e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "25px", // Set your desired border-radius here
                      backgroundColor: "#F4F4F4", // Set your desired background color
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove the outline
                    },
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && input.trim() !== "") {
                      sendMessage();
                    }
                  }}
                  slotProps={{
                    input: {
                      endAdornment:
                        input !== "" ? (
                          <SendIcon
                            style={commonBgColor}
                            onClick={sendMessage}
                            className="cursor-pointer"
                          />
                        ) : (
                          <label>
                            <SendIcon
                              style={commonBgColor}
                              onClick={() => {}}
                            />
                          </label>
                        ),
                    },
                  }}
                />
              </div>

              {/* Emoji Picker */}
              {showEmojiPicker && (
                <div
                  className="flex flex-col"
                  style={{
                    position: "absolute",
                    bottom: "80px",
                    zIndex: 1000,
                  }}
                >
                  <CancelRoundedIcon
                    className="self-end text-[#8a2222] cursor-pointer mb-1"
                    onClick={() => {
                      setShowEmojiPicker(false);
                    }}
                  />
                  <Picker onEmojiSelect={handleEmojiSelect} />
                </div>
              )}
            </div>
          </div>
        ) : (
          // IF NOW CHAT SELECTED
          <div className="flex justify-center items-center flex-col gap-2">
            <img src={startChat} alt="start chat" className="w-[200px]" />
            <Heading
              title={`Choose a ${selectedTabForUser === "Chats" ? "Provider" : "Group"} to Start Chatting`}
            />
          </div>
        )}
      </div>

      {groupNameAndGroupMember && (
        <GroupChatDialog
          //   isEdit={true} //for edit dialog
          dialogHeading={"Edit Group Members"}
          defaultDataForUser={selectedGroupMessages}
          isOpen={groupNameAndGroupMember}
          handleClose={() => setGroupNameAndGroupMember(false)}
          handleData={handlerForAddGroupMemberAndGroupName}
        />
      )}
      {openViewMembersDialog && (
        <ViewMembersDialog
          dialogHeading="View Members"
          isOpen={openViewMembersDialog}
          viewData={selectedGroupMessages}
          handleClose={() => {
            setOpenViewMembersDialog(false); // Close the dialog
          }}
        />
      )}
    </WrapperCard>
  );
};

export default ChatBox;
